import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart, CART_URL } from '../lib/metaPixel';
export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const threshold = () => window.innerHeight * 1.5;
    const onScroll = () => {
      setVisible(window.scrollY > threshold());
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-354">
      {visible && <motion.div initial={{
      y: 110
    }} animate={{
      y: 0
    }} exit={{
      y: 110
    }} transition={{
      type: 'tween',
      duration: 0.25,
      ease: 'easeOut'
    }} className="md:hidden fixed bottom-0 left-0 right-0 z-50 px-3 pb-3 pt-2 bg-gradient-to-t from-black via-black/95 to-black/0" style={{
      paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 0.75rem)'
    }} data-id="element-355">
          <a href={CART_URL} onClick={() => trackAddToCart({
        value: 7.99,
        currency: 'USD',
        content_name: 'Plan Anti Panza'
      })} className="flex items-center justify-between w-full bg-orange-500 hover:bg-orange-400 active:scale-[0.98] text-white font-black px-5 py-4 rounded-2xl shadow-[0_0_40px_rgba(249,115,22,0.5)] transition-transform" data-id="element-356">
            <div className="flex items-baseline gap-2" data-id="element-357">
              <span className="text-xs font-bold uppercase tracking-widest text-white/80 line-through" data-id="element-358">
                $15.98
              </span>
              <span className="text-2xl font-display tracking-tight" data-id="element-359">
                $7.99
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-360">
              <span className="text-base uppercase tracking-wider" data-id="element-361">
                Acceder ahora
              </span>
              <ArrowRightIcon className="w-5 h-5" data-id="element-362" />
            </div>
          </a>
        </motion.div>}
    </AnimatePresence>;
}